import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CONFIG } from 'config';

interface ApiClientProps extends AxiosRequestConfig {
  endpoint: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  data?: any;
}

const BASE_URL =  `${CONFIG.SUFFIX_API_BASE_URL}/v1`;  // replace with your actual base URL

export const apiReportExport = async <T = any>({
  endpoint,
  method = 'GET',
  data,
  responseType,
  ...config
}: ApiClientProps): Promise<AxiosResponse<T>> => {

  const axiosConfig: AxiosRequestConfig = {
    url: `${BASE_URL}${endpoint}`,
    method,
    responseType,
    headers: {
      'Content-Type': 'application/json',
      ...config.headers,
    },
  };

  // ✅ If GET, send data as query params
  if (method.toUpperCase() === 'GET') {
    axiosConfig.params = data;
  } else {
    axiosConfig.data = data;
  }

  const response = await axios<T>(axiosConfig);

  return response;
};